import { Component, OnInit } from '@angular/core';
import { SupportService } from '../../../services/support/support.service';
import packageJson from '../../../../../package.json';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

  public version: string = packageJson.version;
  supportDocs: any = null;
  searchText: string = '';

  activeDoc: any = null; // Track the currently expanded document

  constructor(
    private supportService: SupportService
  ) {
      // Subscribe to support docs
      this.supportService.supportDocs$.subscribe((docs) => {
        console.log('support docs changed:', docs);
        this.supportDocs = docs;
      });

      // Subscribe to the active support document
      this.supportService.supportDoc$.subscribe((doc) => {
        console.log('support doc changed:', doc);
        this.activeDoc = doc; // Set the expanded document to the currently active one
      });
  }

  ngOnInit() {
    this.supportService.refreshContext();

  }

  closeSupport() {
    this.supportService.closeSupport();
  }

  toggleDoc(doc) {
    doc.expanded = !doc.expanded;
  }

  loadDoc = async (docId) => {
    console.log('loadDoc:', docId);
    this.supportService.loadDoc(docId);
  }

  closeDoc() {
    this.supportService.closeDoc();
  }

  clearSearch() {
    this.searchText = '';
    this.searchDocs();
  }

  searchDocs() {
    console.log('searchDocs:', this.searchText);
    this.supportService.searchDocs(this.searchText);
  }

}
